<template>
  <b-row v-if="itemPauta.opcoesVoto && itemPauta.votos">
    <b-col cols="12">
      <b-list-group
        v-for="(voto, idx) in itemPauta.votos.filter(
          voto => listaPorParticipante[voto.participanteId],
        )"
        :key="idx"
        class="mb-1"
      >
        <b-list-group-item active>
          {{ listaPorParticipante[voto.participanteId].unidade.nome }}
          -
          {{ listaPorParticipante[voto.participanteId].unidade.bloco }}
        </b-list-group-item>
        <b-form-radio-group
          v-model="voto.opcaoVotoId"
          :name="`item-${itemPauta.id}-participante-${voto.participanteId}`"
        >
          <b-list-group-item
            v-for="(opVoto, opIndex) in itemPauta.opcoesVoto"
            :key="'op' + opIndex"
            :disabled="!podeVotar"
            class="d-flex justify-content-between align-items-center"
          >
            <span>
              {{ opVoto.titulo }}
            </span>
            <b-form-radio
              v-model="voto.opcaoVotoId"
              :value="opVoto.id"
              :name="`opcao-${opVoto.id}`"
              @change="votar(voto)"
            />
          </b-list-group-item>
        </b-form-radio-group>
      </b-list-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BListGroup,
  BListGroupItem,
  BFormRadio,
  BFormRadioGroup,
} from 'bootstrap-vue'
import AssembleiaAPI from '@/api/assembleia'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BFormRadio,
    BFormRadioGroup,
  },
  props: {
    itemPauta: {
      type: Object,
      required: true,
    },
    assembleia: {
      type: Object,
      required: true,
    },
    listaPresenca: {
      type: Array,
      required: true,
    },
    listaPorParticipante: {
      type: Object,
      required: true,
    },
    podeVotar: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    async votar(voto) {
      try {
        if (!voto.id) {
          const { data: votoNovo } = await AssembleiaAPI.createVoto(
            this.assembleia.id,
            this.itemPauta.id,
            voto,
          )
          this.$emit('votado', { itemPauta: this.itemPauta, voto: votoNovo })
        } else {
          await AssembleiaAPI.patchVoto(
            this.assembleia.id,
            this.itemPauta.id,
            voto,
          )
          this.$emit('votado', { itemPauta: this.itemPauta, voto: { ...voto } })
        }
      } catch (err) {
        this.$toast.error(err.response.data.error)
      }
    },
  },
}
</script>

<style lang="scss"></style>
